/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type FeatureFlagName = typeof FeatureFlagName[keyof typeof FeatureFlagName];


export const FeatureFlagName = {
  FLEET_ALLIES: 'fleet_allies',
  FLEET_CONTRACTS: 'fleet_contracts',
  FLEET_LOGISTICS: 'fleet_logistics',
  FLEET_MISSION_BUILDER: 'fleet_mission_builder',
  FLEET_SQUADRONS: 'fleet_squadrons',
  FLEET_SUBSCRIPTIONS: 'fleet_subscriptions',
  FLEET_TOURS: 'fleet_tours',
  FRIENDS: 'friends',
  HANGAR_INVENTORIES: 'hangar_inventories',
  HOLO_AR: 'holo_ar',
  INVENTORY_TRANSFERS: 'inventory_transfers',
  OAUTH_APPLICATIONS: 'oauth-applications',
  OAUTH_BLUESKY: 'oauth-bluesky',
  OAUTH_CITIZENID: 'oauth-citizenid',
  OAUTH_DISCORD: 'oauth-discord',
  OAUTH_GITHUB: 'oauth-github',
  OAUTH_GOOGLE: 'oauth-google',
  OAUTH_PATREON: 'oauth-patreon',
  OAUTH_TWITCH: 'oauth-twitch',
  ONLINE_STATUS: 'online_status',
  PUSH_NOTIFICATIONS: 'push_notifications',
  SHIP_INVENTORIES: 'ship_inventories',
  TOUR_PAYOUTS: 'tour_payouts',
  TRADE_ROUTES: 'trade_routes',
} as const;
